import React from 'react'


export default function Diagnosis1() {
    return (
       
   
      <div className='section_heading'>
        <h1>Kalpataru <span>Diagnosis</span> Treatment</h1>
        </div>
    

       
    )
}
